import React from 'react';

/**
 * IconInput - a text input with a leading icon on the left.
 *
 * Props:
 *   label    - optional field label
 *   icon     - JSX element rendered inside the left slot (16×16 recommended)
 *   value    - controlled value
 *   onChange - change handler
 *   required - shows * on label
 *   className - extra wrapper classes
 *   ...rest  - forwarded to the underlying <input> (placeholder, type, maxLength, etc.)
 */
const IconInput = ({ label, icon, required = false, className = '', ...rest }) => {
   return (
      <div className={className}>
         {label && (
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
               {label} {required && <span className="text-red-500">*</span>}
            </label>
         )}
         <div className="relative">
            <span className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-gray-400">
               {icon}
            </span>
            <input
               className="w-full pl-9 pr-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-dark-primary text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-dark-accent focus:border-transparent"
               {...rest}
            />
         </div>
      </div>
   );
};

export default IconInput;
